// src/api/apiPrograms.js
import axios from "../utils/axios";

/**
 * Get all programs
 */
export const getAllPrograms = async (page = 1, perPage = 15, filters = {}) => {
    const params = {
        page,
        per_page: perPage,
        ...filters,
    };

    const response = await axios.get("/programs", { params });
    return response.data;
};

/**
 * Get single program
 */
export const getProgram = async (id) => {
    const response = await axios.get(`/programs/${id}`);
    return response.data;
};

/**
 * Create program
 */
export const createProgram = async (data) => {
    const response = await axios.post("/programs", data);
    return response.data;
};

/**
 * Update program
 */
export const updateProgram = async (data, id) => {
    const response = await axios.put(`/programs/${id}`, data);
    return response.data;
};

/**
 * Delete program (soft delete)
 */
export const deleteProgram = async (id) => {
    const response = await axios.delete(`/programs/${id}`);
    return response.data;
};

/**
 * Force delete program
 */
export const forceDeleteProgram = async (id) => {
    const response = await axios.delete(`/programs/${id}/force-delete`);
    return response.data;
};

/**
 * Delete all programs (soft delete)
 */
export const deleteAllPrograms = async (ids) => {
    const response = await axios.delete("/programs/mass-destroy", { data: ids });
    return response.data;
};

/**
 * Force delete all programs
 */
export const forceDeleteAllPrograms = async (ids) => {
    const response = await axios.delete("/programs/mass-force-delete", { data: ids });
    return response.data;
};

/**
 * Restore program
 */
export const restoreProgram = async (id) => {
    const response = await axios.post(`/programs/${id}/restore`);
    return response.data;
};

/**
 * Restore all programs
 */
export const restoreAllPrograms = async (ids) => {
    const response = await axios.post("/programs/mass-restore", { ...ids });
    return response.data;
};

/**
 * Get programs for select dropdown
 */
export const getProgramsForSelect = async () => {
    const response = await axios.get("/programs/for-select");
    return response.data;
};

/**
 * Get PDF sections for program with merged default and custom values
 */
export const getProgramPdfSections = async (id) => {
    const response = await axios.get(`/programs/${id}/pdf-sections`);
    return response.data;
};

/**
 * Save custom PDF section texts for program
 */
export const saveProgramPdfTexts = async (id, data) => {
    const response = await axios.post(`/programs/${id}/save-pdf-texts`, data);
    return response.data;
};

/**
 * Reset PDF section texts to default for program
 */
export const resetProgramPdfTexts = async (id) => {
    const response = await axios.post(`/programs/${id}/reset-pdf-texts`);
    return response.data;
};

/**
 * Confirm program
 */
export const confirmProgram = async (id) => {
    const response = await axios.post(`/programs/${id}/confirm`);
    return response.data;
};

/**
 * Close program
 */
export const closeProgram = async (id) => {
    const response = await axios.post(`/programs/${id}/close`);
    return response.data;
};

/**
 * Export program to PDF from HTML content
 */
export const exportProgramToPdf = async (id, data) => {
    const response = await axios.post(`/programs/${id}/export-pdf`, data, {
        responseType: 'blob'
    });
    return response;
};

/**
 * Convert program currency
 */
export const convertProgramCurrency = async (id, currencyId) => {
    const response = await axios.post(`/programs/${id}/convert-currency`, {
        currency_id: currencyId
    });
    return response.data;
};
